import loadjs from "loadjs";
let templateDirectory = am2.templateDirectory;

export default function() {
  let mailchimpEmbedForm = document.querySelector(".newsletter")

  if (mailchimpEmbedForm) {
    loadjs(`${templateDirectory}/resources/js/vendor/mailchimp-validate.min.js`, () => { console.log ('js-loaded for MC')});
    };
  }
